module.exports = "<hydromet-sidenav layout=row></hydromet-sidenav> <div layout=column flex> <hydromet-toolbar></hydromet-toolbar> <section class=hydromet-outlet flex ui-view> </section> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/hydromet/hydromet.html
 ** module id = 248
 ** module chunks = 0
 **/